import { createStore } from "redux"

const initialState: any = {
  userSession: null,
  notification: null,
  balance: null,
  chosenDirectionTypes: "Исходящие",
  /** Запрос открыть ИИ-помощника по шаблону из глобального справочного центра (обрабатывает EditContractPage) */
  templateAiAssistantOpenRequest: null,
}

function rootReducer(state = initialState, payload: any) {
  return {
    ...state,
    ...payload,
  }
}

export default () => {
  return createStore(rootReducer)
}
